import type { DocCategory } from '../registry';
import InterfaceIndex, { toc as interfaceIndexToc } from '../pages/interface/index';
import SearchTab, { toc as searchTabToc } from '../pages/interface/search';
import MediaTab, { toc as mediaTabToc } from '../pages/interface/media';
import PeopleTab, { toc as peopleTabToc } from '../pages/interface/people';
import SettingsTab, { toc as settingsTabToc } from '../pages/interface/settings';

export const interfaceCategory: DocCategory = {
  id: 'interface',
  label: 'Interface',
  pages: [
    {
      slug: 'interface',
      title: 'The ClipRadar interface',
      eyebrow: 'Interface',
      description: 'Get oriented to the five tabs and the top bar, then dive into any screen.',
      toc: interfaceIndexToc,
      Body: InterfaceIndex,
      related: [
        { label: 'Search tab', to: '/docs/interface/search' },
        { label: 'Media tab', to: '/docs/interface/media' },
        { label: 'The Adobe Premiere Pro panel', to: '/docs/platforms/premiere-panel' },
      ],
    },
    {
      slug: 'interface/search',
      title: 'Search tab',
      eyebrow: 'Interface',
      description: 'Every control on the busiest screen — modes, filters, results, and card actions.',
      toc: searchTabToc,
      Body: SearchTab,
      related: [
        { label: 'Visual search', to: '/docs/concepts/visual-search' },
        { label: 'Get better search results', to: '/docs/guides/search-best-practices' },
        { label: 'From search results to a rough cut', to: '/docs/guides/build-a-rough-cut' },
      ],
    },
    {
      slug: 'interface/media',
      title: 'Media tab',
      eyebrow: 'Interface',
      description: 'Manage indexed sources and drive analysis from the media table.',
      toc: mediaTabToc,
      Body: MediaTab,
      related: [
        { label: 'Analyzing your footage', to: '/docs/concepts/analyzing-media' },
        { label: 'Fix speech & transcript problems', to: '/docs/guides/fix-speech-problems' },
        { label: 'Search tab', to: '/docs/interface/search' },
      ],
    },
    {
      slug: 'interface/people',
      title: 'People tab',
      eyebrow: 'Interface',
      description: 'The People board and Face Collections — name clusters, verify, merge, and maintain.',
      toc: peopleTabToc,
      Body: PeopleTab,
      related: [
        { label: 'People & faces', to: '/docs/concepts/people-and-faces' },
        { label: 'Find & name people', to: '/docs/guides/find-and-name-people' },
      ],
    },
    {
      slug: 'interface/settings',
      title: 'Settings tab',
      eyebrow: 'Interface',
      description: 'A reference for every settings group, grouped cleanly by function.',
      toc: settingsTabToc,
      Body: SettingsTab,
      related: [
        { label: 'AI models & your GPU', to: '/docs/concepts/models-and-your-gpu' },
        { label: 'Licensing & activation', to: '/docs/concepts/licensing' },
        { label: 'Agentic editing (MCP)', to: '/docs/concepts/agentic-editing' },
        { label: 'Where ClipRadar stores things', to: '/docs/reference/where-your-data-lives' },
      ],
    },
  ],
};
